module.exports = __webpack_public_path__ + "img/zcfg.da6cd5f8.png";